<template>
	<table class="wideout">
		<thead>
			<tr>
				<th>Group</th>
				<th>Name</th>
				<th>Default</th>
				<th>Description</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>DCP</td>
				<td>version</td>
				<td>depends</td>
				<td>The version of DCP when the config was generated.</td>
			</tr>
			<tr>
				<td>player_properties</td>
				<td>sprite_base</td>
				<td>sP</td>
				<td>The base string for the player&#39;s sprite. Change this to use NPC sprites. Always wrap with inverted commas, eg <code>&quot;sZomb1&quot;</code>. If there are any sprites missing for your character you will see a grey reaper.</td>
			</tr>
			<tr>
				<td>"</td>
				<td>sprite_removeweaponstring</td>
				<td><span class="color-r">false</span></td>
				<td>Always use <span class="color-g">true</span> if sprite_base is not sP. This makes NPC sprites work.</td>
			</tr>
			<tr>
				<td>"</td>
				<td>run_speed</td>
				<td>2</td>
				<td>How fast you move. Most characters are 2. Amber is the fastest, with 4.</td>
			</tr>
			<tr>
				<td>"</td>
				<td>health</td>
				<td>30</td>
				<td>HP. For an overview of NPC survivability, see the STK (shots to kill) tab in the master data <a target="_blank" href="https://docs.google.com/spreadsheets/d/1qRyF3laHK2bKYyI552aA5PElzib8ak1FfLNxDId9Lzg/edit#gid=1841226704">spreadsheet</a></td>
			</tr>
			<tr>
				<td>"</td>
				<td>blood_type</td>
				<td>5</td>
				<td>Blood colour. 1-3 is red. 4 is grey. 5 is black.</td>
			</tr>
			<tr>
				<td>"</td>
				<td>no_ragdoll</td>
				<td><span class="color-r">false</span></td>
				<td>If <span class="color-g">true</span>, prevents a ragdoll from showing on death. Use <span class="color-g">true</span> if your NPCs has no ragdoll sprites. Most killable enemies do. Try playing  without this enabled; if you see a reaper ragdoll on death, that NPC has no ragdoll sprites.</td>
			</tr>
			<tr>
				<td>player_weapons</td>
				<td>set_primary</td>
				<td>-1</td>
				<td>Primary weapon index. Use -1 for player choice (ie. whatever weapon they last used in the campaign)</td>
			</tr>
			<tr>
				<td>"</td>
				<td>set_secondary</td>
				<td>-1</td>
				<td>Secondary weapon index. Use 4 (the ID for punch) for no weapons.</td>
			</tr>
			<tr>
				<td>"</td>
				<td>ignore_carryover</td>
				<td><span class="color-r">false</span></td>
				<td>If <span class="color-g">true</span>, prevents the player keeping weapons when transitioning between levels. Mainly used for custom campaigns.</td>
			</tr>
			<tr>
				<td>player_canuse</td>
				<td>gun_weapons</td>
				<td><span class="color-g">true</span></td>
				<td>Player can shoot guns. Use <span class="color-r">false</span> if your character has no gun sprites</td>
			</tr>
			<tr>
				<td>"</td>
				<td>melee_smash</td>
				<td><span class="color-g">true</span></td>
				<td>Player can melee attack (eg. knife stab). Use <span class="color-r">false</span> if your character has no melee sprites</td>
			</tr>
			<tr>
				<td>"</td>
				<td>melee_throw</td>
				<td><span class="color-g">true</span></td>
				<td>Player can throw melee weapons (eg throw hammer). Works with any character that has gun sprites.</td>
			</tr>
			<tr>
				<td>"</td>
				<td>vent</td>
				<td><span class="color-g">true</span></td>
				<td>Player can enter and exit vents (only Reaper has the required sprites)</td>
			</tr>
			<tr>
				<td>"</td>
				<td>cover</td>
				<td><span class="color-g">true</span></td>
				<td>Player can hide behind cover (some NPCs do not have cover sprites)</td>
			</tr>
			<tr>
				<td>"</td>
				<td>ladder</td>
				<td><span class="color-g">true</span></td>
				<td>Player can climb ladders (only Reaper has the required sprites)</td>
			</tr>
			<tr>
				<td>"</td>
				<td>weapon_pickups</td>
				<td><span class="color-g">true</span></td>
				<td>Player can pick up weapons (either dropped by enemies or placed in the level)</td>
			</tr>
			<tr>
				<td>"</td>
				<td>cartrunk</td>
				<td><span class="color-g">true</span></td>
				<td>Player can swap weapons via the car trunk</td>
			</tr>
			<tr>
				<td>"</td>
				<td>charon</td>
				<td><span class="color-g">true</span></td>
				<td>Player can interact with Charon and buy new weapons</td>
			</tr>
			<tr>
				<td>weather</td>
				<td>raining</td>
				<td>-1</td>
				<td>If <span class="color-g">true</span>, enables rain. Default (-1) means, enable rain if the player is in hard mode, disable it otherwise</td>
			</tr>
			<tr>
				<td>"</td>
				<td>snowing</td>
				<td>-1</td>
				<td>If <span class="color-g">true</span>, enables snow. Default (-1) means, enable snow if the background is &quot;planes of life&quot;</td>
			</tr>
			<tr>
				<td>"</td>
				<td>multifactor_rain</td>
				<td>-1</td>
				<td>How heavy the rainfall is. The default of -1 means rain heaviness is determined by the player&#39;s current graphics setting (1-3). The number you specify will also be multipled by the player&#39;s graphics settings (eg, if you set 2 and the player&#39;s graphics setting is 3, the rainfall straength in-game will be 6).</td>
			</tr>
			<tr>
				<td>"</td>
				<td>multifactor_snow</td>
				<td>-1</td>
				<td>How heavy the snowfall is. The default of -1 means, on normal mode the heavines is 1, on hard it is 4.</td>
			</tr>
			<tr>
				<td>car_trunk</td>
				<td>NA</td>
				<td>NA</td>
				<td>These settings allow you to access any weapon from the trunk. They will be moved to globalconfig.json in a future version of DCP.</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	export default {
		name: 'LevelConfigSettingsTable'
	}
</script>